"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSchemaModelType = void 0;
exports.model = model;
const util_1 = require("./util");
const Authorization_1 = require("./Authorization");
const ModelIndex_1 = require("./ModelIndex");
const brandName = 'modelType';
function _model(fields) {
    const data = {
        fields,
        identifier: ['id'],
        secondaryIndexes: [],
        authorization: [],
        disabledOperations: [],
    };
    const builder = {
        identifier(identifier) {
            data.identifier = identifier;
            return this;
        },
        secondaryIndexes(callback) {
            data.secondaryIndexes = callback(ModelIndex_1.modelIndex);
            return this;
        },
        disableOperations(ops) {
            data.disabledOperations = ops;
            return this;
        },
        authorization(callback) {
            const { resource: _, ...rest } = Authorization_1.allow;
            const rules = callback(rest);
            data.authorization = Array.isArray(rules) ? rules : [rules];
            return this;
        },
        ...(0, util_1.brand)(brandName),
    };
    return {
        ...builder,
        data,
        relationships(relationships) {
            data.fields = { ...data.fields, ...relationships };
        },
        fields: data.fields,
    };
}
/**
 * Model Type type guard
 * @param modelType - api-next ModelType
 * @returns true if the given value is a ModelSchema
 */
const isSchemaModelType = (modelType) => {
    const internalType = modelType;
    return (typeof internalType === 'object' &&
        internalType.data !== undefined &&
        internalType.data.fields !== undefined &&
        internalType.data.authorization !== undefined &&
        internalType.data.identifier !== undefined &&
        internalType.data.secondaryIndexes !== undefined &&
        typeof internalType.relationships === 'function');
};
exports.isSchemaModelType = isSchemaModelType;
/**
 * A data model that creates a matching Amazon DynamoDB table and provides create, read (list and get), update,
 * delete, and subscription APIs.
 *
 * @param fields database table fields. Supports scalar types and relationship types.
 * @returns a data model definition
 */
function model(fields) {
    return _model(fields);
}
